import React, { useEffect, useState } from 'react'
import InputField from '../../../feature-module/components/Input'
import { Controller, useForm } from 'react-hook-form'
import Select from "react-select";
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import CityServices from '../../../services/City'
import StateServices from '../../../services/State'
import { modalCloseListener } from '../../../utils/helper';

const CityForm = ({ updateData, resetUpdateData, getData }) => {
  console.log('CityForm => updateData:', updateData)

  const { register, handleSubmit, formState: { errors }, setValue, reset, control } = useForm();
  const [loading, setLoading] = useState(false);

  // *For States
  const [states, setStates] = useState([]);

  // *For Get States
  const getStates = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await StateServices.getStates(params)
      setStates(data.map((e) => { return { label: e?.name, value: e?.id } }))
    } catch (error) {
      console.log('getStates => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        state_id: formData?.state?.value,
        name: formData?.name,
        zip_code: formData?.zipCode,
        is_active: formData?.status
      }
      if (updateData?.id) {
        // *Update 
        await CityServices.updateCity(updateData?.id, obj)
        SuccessToaster('Update Successfully')
      } else {
        // *Create 
        await CityServices.createCity(obj)
        SuccessToaster('Create Successfully')
      }
      reset();
      const btn = document.getElementById('modalClose')
      btn.click();
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStates()
    if (updateData) {
      setValue('state', { label: updateData?.state?.name, value: updateData?.state?.id })
      setValue('name', updateData?.name)
      setValue('zipCode', updateData?.zip_code)
      setValue('status', updateData?.is_active)
    }
  }, [updateData]);

  useEffect(() => {
    const cleanup = modalCloseListener("open-modal", () => {
      reset();
      reset({
        state: null,
      })
      resetUpdateData();
    });

    return cleanup;
  }, []);

  return (
    <div className="modal fade" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{updateData?.id ? "Update City" : "Create City"}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body new-employee-field">
                <form onSubmit={handleSubmit(submitForm)}>
                  <div className="mb-3">
                    <label className="form-label">Select State</label>
                    <Controller
                      name="state"
                      control={control}
                      rules={{ required: 'Please select state.' }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Select
                            className={error ? 'is-invalid' : ''}
                            classNamePrefix="react-select"
                            options={states}
                            placeholder="Choose State"
                            {...field}
                          />
                          {error && <div className="invalid-feedback">{error.message}</div>}
                        </>
                      )}
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      label="City Name"
                      type="text"
                      error={errors?.name?.message}
                      register={register("name", {
                        required: 'Please enter city name.',
                      })}
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      label="Zip Code"
                      type="text"
                      error={errors?.zipCode?.message}
                      register={register("zipCode", {
                        required: 'Please enter zip code.',
                      })}
                    />
                  </div>
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label">Status</span>
                      <InputField
                        id="checkbox1"
                        type="checkbox"
                        className="check"
                        defaultChecked={true}
                        register={register("status")}
                      />
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      id="modalClose"
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CityForm
